import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { AuthService } from "~modules/auth/auth.service";

@Component({
  selector: "cq-footer",
  standalone: true,
  templateUrl: "./cq-footer.component.html",
  styleUrl: "./cq-footer.component.scss",
  imports: [CommonModule],
})
export class CQFooterComponent implements OnInit {
  isDictionDisplayed: boolean = false;
  isLogin: boolean = false;

  constructor(private authService: AuthService) {}

  async ngOnInit(): Promise<void> {
    this.isLogin = await this.authService.isAuthenticated();
  }

  openDictionary(): void {
    this.isDictionDisplayed = !this.isDictionDisplayed;
  }
}
